const config = {
  routes: {
    label: 'My Points',
    prefix: '/points',
  },
}

export default config
